import { Link } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";
import { resolveImageUrl } from "./ImagePicker";

export default function ProductCard({ product, className = "" }) {
  const { lang, t } = useI18n();
  return (
    <Link
      to={`/product/${product.id}`}
      className={`block group ${className}`}
      data-testid={`product-card-${product.id}`}
    >
      <div className="product-image-wrap aspect-[4/5] mb-5">
        <img
          src={resolveImageUrl(product.image_url)}
          alt={product.name[lang]}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="font-hand text-3xl leading-tight mb-1" data-testid={`product-name-${product.id}`}>
            {product.name[lang]}
          </h3>
          <div className="label-caps text-muted-foreground">{product.category}</div>
        </div>
        <div className="text-right shrink-0">
          <div className="tag-hand text-2xl text-[hsl(var(--primary))]" data-testid={`product-price-${product.id}`}>
            {product.price.toFixed(2).replace(".", ",")} €
          </div>
          <div className="text-xs text-muted-foreground mt-1">
            {product.stock > 0 ? `${product.stock} ${t("shop.stock")}` : t("shop.outOfStock")}
          </div>
        </div>
      </div>
    </Link>
  );
}
